const invertedMessages = {
  'Single Sign-On (SSO) lets you log in once and access multiple apps or systems without signing in again. It makes login easier and more secure by using one trusted identity provider. Choose a protocol and set up seamless login for your users.':
    'Auth.Description.SSOEmptyState',
  'Enterprise login protocol for single sign-on across multiple apps via an identity provider.':
    'Auth.Description.SAML',
  'Fetch entity descriptor information from an entity descriptor URL.':
    'Auth.Description.MetadataFilePicker.urlOption',
  'Fetch entity descriptor information from a local file.':
    'Auth.Description.MetadataFilePicker.fileOption',
  'Add a new RSA 256 key': 'Auth.Description.AddKey',
  'Choose how the client authenticates: upload a certificate file or provide a JWKS endpoint URL.':
    'Auth.Description.KeySourceTooltip',
  'Upload a new public certificate for client "{name}". This will replace the existing certificate.':
    'Auth.Description.RotateCertificateBody',
  'Saviynt logo': 'Auth.Description.LogoAlt',
};

export default invertedMessages;
